<template>
  <div class="section py-0 px-5">
    <div class="tile app-title">
      <p class="subtitle is-6">Inclure les réseaux confrères</p>
    </div>
    <div class="field">
      <b-switch v-model="avecConfreres" type="is-primary"/>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/venteReseauxTempo-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';

const VenteReseauxTempo = createNamespacedHelpers('venteReseauxTempo');

export default {
  name: 'confreres',
  data() {
    return {
    };
  },
  computed: {
    ...VenteReseauxTempo.mapGetters({
      getAvecConfreres: 'avecConfreres',
    }),
    avecConfreres: {
      get() {
        return this.getAvecConfreres;
      },
      set(value) {
        this.setAvecConfreres(value);
        this.rechercheVentesReseaux();
      },
    },
  },
  methods: {
    ...VenteReseauxTempo.mapMutations({
      setAvecConfreres: types.SET_AVEC_CONFRERES,
    }),
    ...VenteReseauxTempo.mapActions({
      actionRechercheReseaux: 'rechercheReseaux',
    }),
    rechercheVentesReseaux() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.actionRechercheReseaux().then(() => {
        loadingComponent.close();
      }).catch((e) => {
        loadingComponent.close();
        gestionErreur('Erreur lors de la recherche des réseaux tempos liée aux confreres', e);
      });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxTempo/filtres/confreres.vue